import { useStoryblokState } from '@cinch-nx/data-storyblok'
import Head from '@cinch-nx/landing-ui-shared/lib/head/head'
import { StoryblokRenderer } from '@cinch-nx/landing-ui-shared/lib/storyblok-renderer/storyblok-renderer'
import Wrapper from '@cinch-nx/shared-ui/lib/wrapper/wrapper'

import { storyblokComponents } from './data/storyblok-renderer-map'
import type { OurCommitmentFeatureProps } from './get-static-props'
import styles from './our-commitment.module.css'

export function OurCommitmentFeature({
  story,
  generatedAt,
  preview,
}: OurCommitmentFeatureProps) {
  const { content } = useStoryblokState({ story, enableBridge: preview })

  return (
    <>
      <Head
        generatedAt={generatedAt}
        fallbackTitle="Our commitment - cinch"
        fallbackDescription="We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with free home delivery or from an approved dealer."
      />
      <article className={styles.root}>
        <Wrapper isSlim>
          <StoryblokRenderer
            block={content.introSection}
            components={storyblokComponents}
          />
        </Wrapper>
        <Wrapper isSlim>
          <StoryblokRenderer
            block={content.contentWithIconsSection}
            components={storyblokComponents}
          />
        </Wrapper>
        <Wrapper
          isFluid
          backgroundColor="#ECF5FA"
          className={{ container: styles.statsSectionContainer }}
        >
          <StoryblokRenderer
            block={content.statsSection}
            components={storyblokComponents}
            props={{
              trackingEventName: 'Our commitment - Browse all car clicks',
            }}
          />
        </Wrapper>
        <Wrapper isSlim>
          <StoryblokRenderer
            block={content.helpMeChooseSection}
            components={storyblokComponents}
          />
        </Wrapper>
        <StoryblokRenderer
          block={content.preFooterCTASection}
          components={storyblokComponents}
        />
      </article>
    </>
  )
}
